var docTypes = [
    'doc',
    'list'
];
export default docTypes;
